const ELEMENT_ARCANE = 'ELEMENT_ARCANE';
const ELEMENT_COLD = 'ELEMENT_COLD';
const ELEMENT_FIRE = 'ELEMENT_FIRE';
const ELEMENT_PHYSICAL = 'ELEMENT_PHYSICAL';
const ELEMENT_LIGHTNING = 'ELEMENT_LIGHTNING';
const ELEMENT_POISON = 'ELEMENT_POISON';
const ELEMENT_HOLY = 'ELEMENT_HOLY';

const elements = {
  arcane: ELEMENT_ARCANE,
  cold: ELEMENT_COLD,
  fire: ELEMENT_FIRE,
  physical: ELEMENT_PHYSICAL,
  lightning: ELEMENT_LIGHTNING,
  poison: ELEMENT_POISON,
  holy: ELEMENT_HOLY,
};

const SKILL_TREE_PRIMARY = 'SKILL_TREE_PRIMARY';
const SKILL_TREE_SECONDARY = 'SKILL_TREE_SECONDARY';
const SKILL_TREE_DEFENSIVE = 'SKILL_TREE_DEFENSIVE';
const SKILL_TREE_TERROR = 'SKILL_TREE_TERROR';
const SKILL_TREE_DECAY = 'SKILL_TREE_DECAY';
const SKILL_TREE_VOODOO = 'SKILL_TREE_VOODOO';
const SKILL_TREE_FORCE = 'SKILL_TREE_FORCE';
const SKILL_TREE_CONJURATION = 'SKILL_TREE_CONJURATION';
const SKILL_TREE_MASTERY = 'SKILL_TREE_MASTERY';
const SKILL_TREE_MIGHT = 'SKILL_TREE_MIGHT';
const SKILL_TREE_TACTICS = 'SKILL_TREE_TACTICS';
const SKILL_TREE_RAGE = 'SKILL_TREE_RAGE';
const SKILL_TREE_UTILITY = 'SKILL_TREE_UTILITY';
const SKILL_TREE_LAWS = 'SKILL_TREE_LAWS';
const SKILL_TREE_CONVICTION = 'SKILL_TREE_CONVICTION';
const SKILL_TREE_CORPSES = 'SKILL_TREE_CORPSES';
const SKILL_TREE_REANIMATION = 'SKILL_TREE_REANIMATION';
const SKILL_TREE_CURSES = 'SKILL_TREE_CURSES';
const SKILL_TREE_BLOOD_AND_BONE = 'SKILL_TREE_BLOOD_AND_BONE';
const SKILL_TREE_TECHNIQUES = 'SKILL_TREE_TECHNIQUES';
const SKILL_TREE_FOCUS = 'SKILL_TREE_FOCUS';
const SKILL_TREE_MANTRAS = 'SKILL_TREE_MANTRAS';
const SKILL_TREE_HUNTING = 'SKILL_TREE_';
const SKILL_TREE_DEVICES = 'SKILL_TREE_';
const SKILL_TREE_ARCHERY = 'SKILL_TREE_ARCHERY';

const skillTrees = {
  primary: SKILL_TREE_PRIMARY,
  secondary: SKILL_TREE_SECONDARY,
  defensive: SKILL_TREE_DEFENSIVE,
  terror: SKILL_TREE_TERROR,
  decay: SKILL_TREE_DECAY,
  voodoo: SKILL_TREE_VOODOO,
  force: SKILL_TREE_FORCE,
  conjuration: SKILL_TREE_CONJURATION,
  mastery: SKILL_TREE_MASTERY,
  might: SKILL_TREE_MIGHT,
  tactics: SKILL_TREE_TACTICS,
  rage: SKILL_TREE_RAGE,
  utility: SKILL_TREE_UTILITY,
  laws: SKILL_TREE_LAWS,
  conviction: SKILL_TREE_CONVICTION,
  corpses: SKILL_TREE_CORPSES,
  reanimation: SKILL_TREE_REANIMATION,
  curses: SKILL_TREE_CURSES,
  bloodAndBone: SKILL_TREE_BLOOD_AND_BONE,
  techniques: SKILL_TREE_TECHNIQUES,
  focus: SKILL_TREE_FOCUS,
  mantras: SKILL_TREE_MANTRAS,
  hunting: SKILL_TREE_HUNTING,
  devices: SKILL_TREE_DEVICES,
  archery: SKILL_TREE_ARCHERY,
};

const SKILL_TAG_DOT = 'SKILL_TAG_DOT';
const SKILL_TAG_CC = 'SKILL_TAG_CC';
const SKILL_TAG_CHANNELING = 'SKILL_TAG_CHANNELING';
const SKILL_TAG_HEALING = 'SKILL_TAG_HEALING'; // Skills that heal caster in any way
const SKILL_TAG_PET = 'SKILL_TAG_PET';
const SKILL_TAG_COOLDOWN = 'SKILL_COOLDOWN'; // Skills that have cooldown
const SKILL_TAG_MOBILITY = 'SKILL_MOBILITY'; // Skills that increase mobility
const SKILL_TAG_TOUGHNESS = 'SKILL_TOUGHNESS'; // Skills that boost defence in any way
const SKILL_TAG_DAMAGE_BOOST = 'SKILL_DAMAGE_BOOST'; // Skills that boost damage in any way
const SKILL_TAG_RESOURCE = 'SKILL_RESOURCE'; // Skills that grant resource
const SKILL_TAG_WEAKEN = 'SKILL_WEAKEN'; // Skills that weaken enemy = they take more damage or deal less

const skillTypes = {
  dot: SKILL_TAG_DOT,
  cc: SKILL_TAG_CC,
  channeling: SKILL_TAG_CHANNELING,
  healing: SKILL_TAG_HEALING,
  pet: SKILL_TAG_PET,
  cooldown: SKILL_TAG_COOLDOWN,
  mobility: SKILL_TAG_MOBILITY,
  toughness: SKILL_TAG_TOUGHNESS,
  damageBoost: SKILL_TAG_DAMAGE_BOOST,
  resource: SKILL_TAG_RESOURCE,
  weaken: SKILL_TAG_WEAKEN,
};

const PASSIVE_TAG_OFFENSIVE = 'PASSIVE_TAG_OFFENSIVE';
const PASSIVE_TAG_DEFENSIVE = 'PASSIVE_TAG_DEFENSIVE';
const PASSIVE_TAG_RESOURCE = 'PASSIVE_TAG_RESOURCE';
const PASSIVE_TAG_MOBILITY = 'PASSIVE_TAG_MOBILITY';
const PASSIVE_TAG_COOLDOWN = 'PASSIVE_TAG_COOLDOWN';
const PASSIVE_TAG_HEALING = 'PASSIVE_TAG_HEALING';

const passives = {
  offensivePassive: PASSIVE_TAG_OFFENSIVE,
  defensivePassive: PASSIVE_TAG_DEFENSIVE,
  resourcePassive: PASSIVE_TAG_RESOURCE,
  mobilityPassive: PASSIVE_TAG_MOBILITY,
  cooldownPassive: PASSIVE_TAG_COOLDOWN,
  healingPassive: PASSIVE_TAG_HEALING,
};

export default {
  skillTypes,
  elements,
  skillTrees,
  passives,
};
